import { useLoginUserMutation } from "../store/services/loginRegisterQuery";

export const useLoginPage = () => {
  const [
    loginUser,
    {
      data: loginUserData,
      isLoading: loginUserIsLoading,
      isSuccess: loginUserIsSuccess,
      isError: loginUserIsError,
      error: loginUserError,
    },
  ] = useLoginUserMutation();
  return {
    loginUser,
    loginUserData,
    loginUserIsLoading,
    loginUserIsSuccess,
    loginUserIsError,
    loginUserError,
  };
};
